export default __webpack_public_path__ + "static/media/ic_warning.3fec0bc2.svg";